import React, {useState} from 'react';
import {Button, Dropdown, Menu, Grid} from 'antd';
import {FileTextOutlined, DownOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import ProfileModal from '../../components/ProfileModal';
import {getCurrentUserProfile} from '../../utils/userStorage';
import createDocument from '../../utils/document/createDocument';
import {toast} from 'react-hot-toast';

const {useBreakpoint} = Grid;

function hasMissingRequiredFields(profile) {
  return !profile.full_name || !profile.specialty;
}

export default function BaseGenerateDocumentButton({patient, onGenerateClicked, onDocumentCreated, buttonProps = {}}) {
  const {t} = useTranslation();
  const screens = useBreakpoint();

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);

  // load all doc types from locale
  const docTypes = t('patient_documents.types', { returnObjects: true });
  const profile = getCurrentUserProfile();
  const isMissingRequiredFields = hasMissingRequiredFields(profile);

  const handleButtonClick = () => {
    setIsLoading(true);

    if (isMissingRequiredFields) {
      setShowProfileModal(true);
    } else {
      setMenuVisible(true);
    }
    setIsLoading(false);
  };

  const handleMenuClick = async ({key}) => {
    setMenuVisible(false);
    setIsLoading(true);
    try {
      await createDocument(patient.getUUID(), key);
      onGenerateClicked?.();
      onDocumentCreated?.();
    } catch (error) {
      toast.error(t('patient_documents.errors.create'));
    } finally {
      setIsLoading(false);
    }
  };

  const menu = {
    items: Object.entries(docTypes).map(([key, label]) => ({
      key,
      label: <span style={{ fontSize: 16 }}>{label}</span>,
    })),
    onClick: handleMenuClick,
  };

  const renderButton = (showDropdown = true) => (
    <Button
      loading={isLoading}
      size="middle"
      type="default"
      icon={<FileTextOutlined/>}
      onClick={handleButtonClick}
      {...buttonProps}>
      {t('patient_documents.generate_document')}
      {showDropdown && <DownOutlined style={{ marginLeft: 8 }} />}
    </Button>
  );

  return (
    <>
      {isMissingRequiredFields ? (
        renderButton(false)
      ) : (
      <Dropdown
        menu={menu}
        placement="bottomRight"
        trigger={['hover']}
      >
        {renderButton(true)}
      </Dropdown>
      )}

      <ProfileModal
        open={showProfileModal}
        onClose={() => {
          setShowProfileModal(false);
          // Check if required fields are set after modal closes
          const profile = getCurrentUserProfile();
          if (!hasMissingRequiredFields(profile)) {
            // Add a small delay to ensure component is mounted
            setTimeout(() => {
              setMenuVisible(true);
            }, 100);
          }
        }}
      />
    </>
  );
} 